import { Select } from "components/shared/form";
import React, { useState } from "react";
import { list } from "sources/books/employees";
import { addUser } from "sources/books/usersGroups";

export default function AddUserToGroup(props) {
    const [data, setData] = useState({ userId: null, groupId: props.groupId });
    const [loading, setLoading] = useState(false);
    const handleSubmit = () => {
        setLoading(true);
        addUser(data).then((res) => {
            if (res) {
                props.mergeParams();
                props.back();
            }
            setLoading(false);
        });
    };

    return (
        <div className={loading ? "loading" : ""}>
            <Select
                label="Пользователь"
                inputProps={{ name: "userId" }}
                onChange={({ name, value }) => setData({ ...data, [name]: value })}
                value={data.userId}
                url={list}
                propName="fullNameOrEmail"
                menuPortalTarget={document.body}
            />
            <div className="d-flex justify-content-end">
                <div className="btn btn-sm btn-brand" onClick={handleSubmit}>
                    Сохранить
                </div>
            </div>
        </div>
    );
}
